import { h } from 'preact';
import styles from './Layout.module.scss';
export function Layout({ sidebar, main, layout, openFilterDrawer, setOpenFilterDrawer }) {
    return (h("div", { class: styles.container },
        openFilterDrawer && (h("div", { class: styles.filterOverlay, onClick: () => setOpenFilterDrawer(false) })),
        h("aside", { class: `${styles.filterDrawer} ${openFilterDrawer ? styles.openDrawer : ''}` }, sidebar),
        h("main", { class: `${styles.main} ${openFilterDrawer ? styles.mainBlurred : ''}`, "data-layout": layout.cardLayout }, main)));
}
